import React, { FC } from 'react';
import { Label } from '../TypographyNew';
import { CheckboxContainer } from './Checkbox.styles';
import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import { nanoid } from 'nanoid';

type CheckboxProps = {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  className?: string;
  onChange?: F0;
};

const noop = () => {};

export const Checkbox: FC<CheckboxProps> = ({
  checked = false,
  disabled,
  label,
  onChange = noop,
  className,
}) => {
  const id = nanoid();

  const iconName: TrevorIconName = checked
    ? 'checkbox-control-selected'
    : 'checkbox-control-unselected';

  return (
    <CheckboxContainer className={className}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={id}>
        <TrevorIcon name={iconName} />
        <Label variant={1}>{label}</Label>
      </label>
    </CheckboxContainer>
  );
};
